<template>
    <div>
        <fieldset class="kgr-inputGroup kgr-row">
            <div class="kgr-inputGroup__label">
                {{ $t('Kindstatus:') }}
            </div>
            <label
                v-for="filter in filters"
                class="kgr-checkbox kgr-checkbox--inline"
            >
                <input
                    v-model="filter.checked"
                    type="checkbox"
                    name="status[]"
                    class="kgr-checkbox__control"
                    @change="saveStatusFilter()"
                />
                <span class="kgr-checkbox__label">{{ $t('group.children.child_status_' + filter.name) }}</span>
            </label>
        </fieldset>

        <label class="kgr-checkbox kgr-row">
            <input
                v-model="inGroupFilter"
                type="checkbox"
                class="kgr-checkbox__control"
                @change="saveInGroupFilter()"
            />
            <span class="kgr-checkbox__label">{{ $t('Auch Kinder anzeigen, die aktuell der Gruppe zugeordnet sind') }}</span>
        </label>

        <table class="kgr-table kgr-table--striped kgr-table--block table-groups table-list printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Status') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Vorname') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Nachname') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Geburtsdatum') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Alter') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Regelgruppe') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Gruppenzuordnung') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions">
                        {{ $t('options') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="child in filteredChildren"
                    class="kgr-table__row"
                    :class="{ 'is-inactive': child.is_in_selected_group }"
                >
                    <td
                        :title="$t('group.children.child_status_' + child.contract_status)"
                        class="kgr-table__cell"
                    >
                        <kgr-child-status-icon :status="child.contract_status" />
                    </td>
                    <td class="kgr-table__cell">
                        <a
                            :href="showRoute(child.id)"
                            target="_blank"
                            class="kgr-link kgr-link--unobtrusive"
                        >{{ child.firstname }}</a>
                    </td>
                    <td class="kgr-table__cell">
                        {{ child.lastname }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ child.date_of_birth }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ child.age }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ child.regular_group_name }}
                    </td>
                    <td class="kgr-table__cell">
                        <label class="kgr-checkbox">
                            <input
                                v-model="selectedIds"
                                type="checkbox"
                                name="selected_children[]"
                                :value="child.id"
                                :disabled="child.is_in_selected_group"
                                class="kgr-checkbox__control"
                            />
                            <span class="kgr-checkbox__label"></span>
                        </label>
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions">
                        <a
                            v-if="child.has_write_access"
                            :href="editRoute(child.id)"
                            target="_blank"
                            :title="$t('Bearbeiten')"
                            class="kgr-table__action"
                        >
                            <kgr-icon icon-class="edit" />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import ChildStatusIcon from '../../components/child/contract/ChildStatusIcon.vue';
import Icon from '../common/icon/Icon.vue';

export default {
    components: {
        'kgr-child-status-icon': ChildStatusIcon,
        'kgr-icon': Icon,
    },
    props: {
        childlist: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            filters: [
                { name: 'archived', checked: true, },
                { name: 'active', checked: true, },
                { name: 'waiting_for_contract_start', checked: true, },
                { name: 'waiting_for_contract_signing', checked: true, },
                { name: 'on_waiting_list', checked: true, },
                { name: 'signed_up', checked: true, },
                { name: 'created', checked: true, },
            ],
            inGroupFilter: false,
            selectedIds: [],
        }
    },
    computed: {
        filteredChildren() {
            let childlist = this.childlist;

            let filtersToApply = this.filters.filter(filter => !filter.checked);
            filtersToApply.forEach(filter => childlist = childlist.filter(child => child.contract_status !== filter.name));

            if (!this.inGroupFilter) {
                childlist = childlist.filter(child => !child.is_in_selected_group);
            }

            return childlist;
        }
    },
    mounted() {
        let filters = localStorage.getItem('group_children_add_filter');
        if (filters) {
            this.filters = JSON.parse(filters);
        }

        let inGroupFilter = localStorage.getItem('group_children_in_group');
        if (inGroupFilter) {
            this.inGroupFilter = JSON.parse(inGroupFilter);
        }
        this.selectedIds = this.childlist.filter(child => child.is_in_selected_group).map(child => child.id);
    },
    methods: {
        showRoute(childId) {
            return `/backend/child/${childId}/show`;
        },
        editRoute(childId) {
            return `/backend/child/${childId}/edit`;
        },
        saveStatusFilter() {
            localStorage.setItem('group_children_add_filter', JSON.stringify(this.filters));
        },
        saveInGroupFilter() {
            localStorage.setItem('group_children_in_group', JSON.stringify(this.inGroupFilter));
        },
    }
}
</script>
